import React from 'react';
import styled from 'styled-components';

import IconAdd from '@tvg/fuse-icons/lib/Add';
import IconRemove from '@tvg/fuse-icons/lib/Remove';
import { Link } from '@tvg/fuse-design';

const ShowMoreLink = styled(Link)`
  cursor: pointer;
`;

type Props = {
  isExpanded: boolean;
  setIsExpanded: (arg: boolean) => void;
};

function ShowMoreOption(props: Props) {
  const { isExpanded, setIsExpanded } = props;

  return (
    <ShowMoreLink
      data-testid="show-more-option"
      icon={isExpanded ? <IconRemove /> : <IconAdd />}
      iconRight
      size="medium"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      Show {isExpanded ? 'less' : 'more'}
    </ShowMoreLink>
  );
}

export default ShowMoreOption;
